import CrudAccessManager from '@/classes/clientOnly/permissionTreeResources/classes/CrudAccessManager';
import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {CrudActionTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudActionTypes';

/** Route of the office overview „Offene Protokolle pro Lehrkraft“ */
export const MISSING_COURSE_LOGS_OVERVIEW_PATH = '/stats/missing-course-logs';

/**
 * Same guard as payoff-manager `missing-logs/overview` and `remind`: read access on all log entries and all courses.
 */
export function canSeeMissingCourseLogsOverview(crudAccessManager: CrudAccessManager): boolean {
    return crudAccessManager.getAccessibleEntities(CrudEntityTypes.LOG_ENTRY, CrudActionTypes.READ) === 'all'
        && crudAccessManager.getAccessibleEntities(CrudEntityTypes.COURSE, CrudActionTypes.READ) === 'all';
}

/** "1 Kurstermin" / "3 Kurstermine" */
export const courseDatesText = (count: number): string => (count === 1 ? '1 Kurstermin' : `${count} Kurstermine`);
